import { MediaTypeDefinitions } from 'Types/Tasks.types'
import Paragraph from 'antd/lib/typography/Paragraph'
import styles from '../Prompt.module.less'

type PromptImageContentPropsType = {
    content: MediaTypeDefinitions
    id: string
}

export const PromptImageContent = (props: PromptImageContentPropsType) => {
    return (
        <div className={styles['image-content']} id={props.id}>
            <Paragraph className={styles['image-content-tile']}>{props.content.label}</Paragraph>
            <img src={props.content.url} alt={props.content.label} />
        </div>
    )
}
